import {
  Http
} from '../utils/http.js';
class Home extends Http {

  webHomePage(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/OpenPage/WebHomePage",
      method: "post",
      param: param
    })
  }
}
export {
  Home
}